import { Area } from 'os/shared/utils/src/types/Area';
import { Size } from 'os/shared/utils/src/types/Size';

export const calculateOffset = (
    imageSize: Size,
    cropBox: Area,
    containerSize: Size,
    zoom: number
) => {

    const centerX = 0.5 * imageSize.width;
    const centerY = 0.5 * imageSize.height;

    const cropX = cropBox.x + 0.5 * cropBox.width;
    const cropY = cropBox.y + 0.5 * cropBox.height;

    const offsetRatioX = (centerX - cropX) / cropBox.width;
    const offsetRatioY = (centerY - cropY) / cropBox.height;

    return {
        x: containerSize.width / zoom * offsetRatioX,
        y: containerSize.height / zoom * offsetRatioY
    };
};